import { ResponsibleHist } from "../../../general/src/ResponsibleHist";
import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMovementUsers extends Layout {
    layoutResponsibleHist: ResponsibleHist;
    sourceMovement: DataSource;
    sourceResponsibleHist: DataSource;
    textboxDispatcherUserId: Textbox;
    textboxFleetManager: Textbox;
    textboxOperationsUser: Textbox;
}
